exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px){.q-btn-iqos[data-v-39e29df8]{letter-spacing:.125rem;text-transform:capitalize;font-size:17px!important;border-width:2px;padding:0 50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39e29df8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/lending-point/orderForm.vue
// module id = DgZ8
// module chunks = 44